// eslint-disable-next-line import/prefer-default-export
export const mainBackgroundStyles = {
  background: (theme: any) => theme.palette.background.mainBg,
  minHeight: "calc(100% - 64px)",
};
